
export default {
  home: () => import('./home/home'),
  comments: () => import('./comments/comments'),
  cookies: () => import('./cookies/cookies'),
  ratingInput: () => import('./ratingInput/ratingInput'),
}
